module.exports = __webpack_public_path__ + "img/free10_800x400.71ca0372.jpg";